import { DEALERSHIP_CONFIG } from "../config/dealershipConfig";
import { apiRequest } from "./apiService";

export async function createDealershipUser(
  quizSelections,
  dealershipId,
  userSource,
  dealershipQuizIndexMapping,
  salesPersonId,
  salesPersonEmail,
  salesPersonOid,
  recordingSessionUUID,
  trackingId
) {
  if (
    !Array.isArray(quizSelections) ||
    !quizSelections.every(
      (quizResponse) => quizResponse.questionId !== undefined
    )
  ) {
    return null;
  }
  if (!dealershipId || !Object.keys(DEALERSHIP_CONFIG).includes(dealershipId)) {
    return null;
  }

  try {
    const res = await apiRequest(
      "/dealershipuser/createdealershipuser",
      "POST",
      {
        selected: quizSelections,
        dealershipQuizIndexMapping,
        dealershipId,
        userSource,
        salesPersonId,
        salesPersonEmail,
        salesPersonOid,
        recordingSessionUUID,
        trackingId,
      }
    );
    return res;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function getDealershipUserInfo(
  id,
  openedThroughEmail,
  dealershipId
) {
  try {
    const res = await apiRequest(
      "/dealershipuser/getdealershipuserinfo",
      "POST",
      {
        userId: id,
        openedThroughEmail: Number(openedThroughEmail),
        dealershipId,
      }
    );
    return (
      res || {
        inventoryMatches: [],
        maeTrimsMatches: [],
        user: {},
        quizIndexMapping: {},
      }
    );
  } catch (error) {
    console.log(error);
    return {
      inventoryMatches: [],
      maeTrimsMatches: [],
      user: {},
      quizIndexMapping: {},
    };
  }
}

export async function updateFinancePreapprovalAndTestDriveInfo(
  userId,
  financePreApprovalAndTestDriveObj
) {
  try {
    const res = await apiRequest(
      "/dealershipuser/updateFinancePreapprovalAndTestDriveInfo",
      "POST",
      {
        userId,
        financePreApprovalAndTestDriveObj,
      }
    );
    return res;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function updateUserProfile(
  userId,
  updatedProfileResponses,
  dealershipId
) {
  try {
    const res = await apiRequest("/dealershipuser/updateuserprofile", "POST", {
      userId,
      updatedProfileResponses,
      dealershipId,
    });
    return res;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function updateComparisonChartStates(
  userID,
  comparisonChartStates
) {
  try {
    const res = await apiRequest(
      "/dealershipuser/updatecomparisonchartstates",
      "POST",
      {
        userID,
        comparisonChartStates,
      }
    );
    return res;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function saveAIChatMessages(AIChatMessages, userID) {
  try {
    const res = await apiRequest("/dealershipuser/saveaichatmessages", "POST", {
      AIChatMessages,
      userID,
    });
    const { updatedUser, message } = res;
    console.log(message);
    return updatedUser;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function sendFinanceAndInsuranceFormText(userId) {
  try {
    const res = await apiRequest("/dealershipuser/sendForm", "POST", {
      userId,
      domain: "dealer-sales-copilot",
    });
    return res;
  } catch (error) {
    console.log(error);
    return null;
  }
}
